export default __webpack_public_path__ + "static/media/mtr1.434cc9cf.png";